module.exports = __webpack_public_path__ + "static/img/home-group5.f3f08226.png";